"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const contact_sheet_model_1 = require("../models/contact-sheet.model");
const applicationConfiguration_provider_1 = require("../../xccti/services/applicationConfiguration.provider");
const lodash_2 = require("lodash");
class ContactService {
    constructor($window, callContext, JitsiProxy, XucPhoneState, CtiProxy, $log, applicationConfiguration, $translate, XucUtils, $state, toast) {
        this.$window = $window;
        this.callContext = callContext;
        this.JitsiProxy = JitsiProxy;
        this.XucPhoneState = XucPhoneState;
        this.CtiProxy = CtiProxy;
        this.$log = $log;
        this.applicationConfiguration = applicationConfiguration;
        this.$translate = $translate;
        this.XucUtils = XucUtils;
        this.$state = $state;
        this.toast = toast;
        this.getTranslationType = (type) => {
            switch (type) {
                case 'meetingroom':
                    return 'MEETINGROOM_COPIED';
                case 'phone':
                    return 'PHONE_COPIED';
                case 'email':
                    return 'EMAIL_COPIED';
            }
        };
        this.appConfig = this.applicationConfiguration.getCurrentAppConfig();
    }
    audioInviteContext(contact) {
        return (!lodash_2.isNil(contact.actions[contact_sheet_model_1.ContactSheetActionEnum.AudioInvite]) && this.userWithInviteToConferenceIcon(contact) || this.meetingRoomWithInviteToConferenceIcon(contact));
    }
    execContextualPhoneAction(contact, nb, $event) {
        if (this.audioInviteContext(contact)) {
            this.inviteToConference(contact, $event, nb);
        }
        else
            this.makeACall(contact, $event, nb);
    }
    getContextualPhoneClass(contact) {
        if (this.audioInviteContext(contact)) {
            return "xivo-include-call-audioconf";
        }
        else
            return "xivo-telephone";
    }
    canShareLink(contact) {
        return contact.isMeetingroom && (contact.actions[contact_sheet_model_1.ContactSheetActionEnum.ShareLink] !== undefined);
    }
    getFieldDataFormatted(contact, field) {
        switch (field.dataType) {
            case 'PhoneNumber':
                return contact.isMeetingroom ? '**' + field.data : this.XucUtils.prettyPhoneNb(field.data);
            default:
                return field.data;
        }
    }
    getPhoneStateBackColor(contact) {
        if (contact.status.video === "Busy")
            return "user-videostatus-" + contact.status.video;
        if (contact.isMeetingroom)
            return "user-meetingroom";
        return "user-status" + contact.status.phone + (contact.keydown ? " lighter" : "");
    }
    getPhoneStateLabel(contact) {
        if (contact.status.video === 'Busy')
            return "USER_VIDEOSTATUS_" + contact.status.video;
        return "USER_STATUS_" + contact.status.phone;
    }
    navigateToContactEditor(contact) {
        if (contact.isMeetingroom) {
            this.$state.go("interface.meetingRooms", { id: contact.sources[0].id });
        }
        else {
            this.$state.go("interface.personalContact", { id: contact.sources[0].id });
        }
    }
    isJitsiAvailable() {
        return this.JitsiProxy.jitsiAvailable;
    }
    generateMeetingShareLink(contact) {
        let args = contact.actions[contact_sheet_model_1.ContactSheetActionEnum.ShareLink].args;
        return `${this.$window.location.origin}${args ? args[0] : ''}`;
    }
    inviteToConference(contact, $event, nb = contact.actions[contact_sheet_model_1.ContactSheetActionEnum.Call].args[0]) {
        $event.stopPropagation();
        let conference = this.XucPhoneState.getConference();
        if (conference !== undefined) {
            this.CtiProxy.conferenceInvite(conference.conferenceNumber, nb, 'User', true);
        }
    }
    userWithInviteToConferenceIcon(contact) {
        return this.canInviteToConference() && this.isCallable(contact) && !contact.isMeetingroom;
    }
    meetingRoomWithInviteToConferenceIcon(contact) {
        return this.canInviteToConference() && contact.isMeetingroom && this.isJitsiAvailable();
    }
    canInviteToMeetingRoom(contact) {
        return this.JitsiProxy.videoIsOngoing() &&
            !contact.isMeetingroom &&
            !contact.isPersonal &&
            contact.actions[contact_sheet_model_1.ContactSheetActionEnum.Video];
    }
    canInviteToConference() {
        return this.XucPhoneState.getConferenceOrganizer();
    }
    isCallable(contact) {
        return contact.actions[contact_sheet_model_1.ContactSheetActionEnum.Call] != undefined
            || contact.actions[contact_sheet_model_1.ContactSheetActionEnum.Video] != undefined
            || this.callContext.isMeetingRoom(contact);
    }
    inviteToMeetingRoom(contact) {
        this.JitsiProxy.inviteToMeetingRoom(contact.actions[contact_sheet_model_1.ContactSheetActionEnum.Video].args[0], contact.name);
    }
    userWithCallIcon(contact) {
        return !this.canInviteToConference()
            && this.isCallable(contact)
            && !contact.isMeetingroom
            && !this.hasJustEmail(contact);
    }
    meetingRoomWithCallIcon(contact) {
        return !this.canInviteToConference()
            && contact.isMeetingroom
            && this.isJitsiAvailable();
    }
    hasJustEmail(contact) {
        const emailAction = contact.actions[contact_sheet_model_1.ContactSheetActionEnum.Mail];
        const otherAction = Object
            .entries(contact.actions)
            .filter(([key, value]) => key != "Email" && value);
        if (!otherAction
            && emailAction
            && emailAction.args.length != 0
            && emailAction.args[0] != "") {
            return true;
        }
        else
            return false;
    }
    getMailToLink(contact) {
        return this.generateMailToLink(contact);
    }
    getFieldMailToLink(contact, field) {
        return this.generateMailToLink(contact, field.data);
    }
    getFieldAction(field, contact, $event) {
        $event.stopPropagation();
        switch (field.dataType) {
            case 'PhoneNumber':
                return this.makeACall(contact, $event, field.data);
            case 'Mail':
                return this.getMailToLink(contact);
            default:
                return;
        }
    }
    startPointToPointVideoCall(contact, $event) {
        $event.stopPropagation();
        this.JitsiProxy.startPointToPointVideoCall(contact.actions[contact_sheet_model_1.ContactSheetActionEnum.Video].args[0], contact.name);
    }
    dial(number) {
        this.callContext.normalizeDialOrAttTrans(number);
    }
    makeACall(contact, $event, phone) {
        $event.stopPropagation();
        let args = contact.actions[contact_sheet_model_1.ContactSheetActionEnum.Call].args;
        let number = args ? args[0] : '';
        if (contact.isMeetingroom) {
            return this.dial('**' + number);
        }
        return this.dial(phone || number);
    }
    makeAVideoCall(contact, $event) {
        $event.stopPropagation();
        if (contact.isMeetingroom) {
            return this.join(contact);
        }
        return this.startPointToPointVideoCall(contact, $event);
    }
    _isPersonal(meetingRoomContact) {
        return meetingRoomContact.isPersonal ? 'personal' : 'static';
    }
    join(contact, $event) {
        $event === null || $event === void 0 ? void 0 : $event.stopPropagation();
        if (contact.isMeetingroom) {
            this.JitsiProxy.startVideo(contact.actions[contact_sheet_model_1.ContactSheetActionEnum.Video].args[0], this._isPersonal(contact)).then(() => this.XucPhoneState.getCallsNotOnHold().forEach((call) => this.CtiProxy.hold(call.uniqueId))).catch((error) => this.$log.error("Cannot start meeting room", error));
        }
    }
    generateMailToLink(contact, fieldEmail) {
        const template = this.appConfig.mailTemplate;
        const fullName = contact.name;
        const email = fieldEmail === undefined ? (contact.actions[contact_sheet_model_1.ContactSheetActionEnum.Mail] && contact.actions[contact_sheet_model_1.ContactSheetActionEnum.Mail].args && contact.actions[contact_sheet_model_1.ContactSheetActionEnum.Mail].args[0] ? contact.actions[contact_sheet_model_1.ContactSheetActionEnum.Mail].args[0] : '') : fieldEmail;
        const calls = this.XucPhoneState.getCalls();
        const callerNum = lodash_1.default.get(calls.find((call) => call.otherDN !== 'anonymous'), 'otherDN');
        const subject = this.replaceVariables(template.subject, callerNum, fullName);
        const body = this.replaceVariables(template.body, callerNum, fullName);
        return encodeURI(`mailTo:${email}?subject=${subject}&body=${body}`);
    }
    replaceVariables(text, callerNum, fullName) {
        const replace = (text, pattern, value, fallback) => {
            let v = value ? value : `###${this.$translate.instant(fallback)}###`;
            let r = new RegExp(pattern, "g");
            return text.replace(r, v);
        };
        text = replace(text, '{callernum}', callerNum, 'PLACEHOLDER_NUMBER');
        text = replace(text, '{dstname}', fullName, 'PLACEHOLDER_NAME');
        return text;
    }
    clipboardPopup(field, $event) {
        $event.stopPropagation();
        this.toast({
            duration: 3000,
            message: this.$translate.instant(this.getTranslationType(field)),
            className: 'alert-copied',
            position: 'center',
            container: '.toast-container'
        });
    }
    getActionsProperties(closeContactSheetCallback) {
        const actions = {
            'Edit': {
                class: 'edit',
                id: 'edit-contact-button',
                icon: `<span class='nd-action-button'><i class='xivo-modifier'></i></span>`,
                title: 'EDIT',
                onClick: (contact, $event) => {
                    $event.stopPropagation();
                    this.navigateToContactEditor(contact);
                },
                displayCondition: (contact) => contact.isPersonal && this.appConfig.appType == applicationConfiguration_provider_1.AppType.UCAssistant,
                disableCondition: (contact) => contact.actions['Edit'].disable
            },
            'Call': {
                class: 'call',
                id: 'call-contact-button',
                icon: `<span class="nd-action-button"><i class='xivo-telephone'></i></span>`,
                title: 'PHONE_CALL',
                onClick: (contact, $event) => {
                    $event.stopPropagation();
                    this.makeACall(contact, $event);
                    closeContactSheetCallback === null || closeContactSheetCallback === void 0 ? void 0 : closeContactSheetCallback();
                },
                displayCondition: (contact) => !lodash_2.isNil(contact.actions[contact_sheet_model_1.ContactSheetActionEnum.Call]) && this.userWithCallIcon(contact) || this.meetingRoomWithCallIcon(contact) || !lodash_2.isNil(contact.actions[contact_sheet_model_1.ContactSheetActionEnum.AudioInvite]) && this.userWithInviteToConferenceIcon(contact) || this.meetingRoomWithInviteToConferenceIcon(contact),
                disableCondition: (contact) => contact.actions['Call'].disable
            },
            'Video': {
                class: 'video-call',
                id: 'video-contact-button',
                icon: `<span class="nd-action-button"><i class="xivo-appel-visio"></i></span>`,
                title: 'P2P_VIDEO_CALL',
                onClick: (contact, $event) => {
                    $event.stopPropagation();
                    contact.isMeetingroom ? this.join(contact, $event) : this.startPointToPointVideoCall(contact, $event);
                    closeContactSheetCallback === null || closeContactSheetCallback === void 0 ? void 0 : closeContactSheetCallback();
                },
                displayCondition: (contact) => !lodash_2.isNil(contact.actions[contact_sheet_model_1.ContactSheetActionEnum.Video]) && this.isJitsiAvailable() && !this.canInviteToMeetingRoom(contact),
                disableCondition: (contact) => contact.actions['Video'].disable
            },
            'Chat': {
                class: 'comments',
                id: 'chat-contact-button',
                icon: `<span class="nd-action-button"><i class="xivo-message"></i></span>`,
                title: 'CHAT',
                onClick: (contact, $event) => {
                    $event.stopPropagation();
                    let username = contact.actions.Chat ? contact.actions.Chat.args[0] : '';
                    this.$state.go(this.appConfig.routing + '.conversation', { remoteParty: username });
                    closeContactSheetCallback === null || closeContactSheetCallback === void 0 ? void 0 : closeContactSheetCallback();
                },
                displayCondition: (contact) => !lodash_2.isNil(contact.actions[contact_sheet_model_1.ContactSheetActionEnum.Chat]),
                disableCondition: (contact) => contact.actions['Chat'].disable || !this.appConfig.chat
            },
            'Mail': {
                class: '',
                id: 'mail-contact-button',
                icon: `<span class="nd-action-button"><i class='fas fa-envelope'></i></span>`,
                title: 'SEND_EMAIL',
                onClick: (contact, $event) => {
                    $event.stopPropagation();
                    window.location.href = this.generateMailToLink(contact);
                },
                displayCondition: (contact) => !lodash_2.isNil(contact.actions[contact_sheet_model_1.ContactSheetActionEnum.Mail]),
                disableCondition: (contact) => contact.actions['Mail'].disable
            },
            'ShareLink': {
                class: 'share',
                id: 'sharelink-contact-button',
                icon: `<span class='nd-action-button'><i class='fas fa-share-alt'></i></span>`,
                title: 'SHARE_LINK',
                onClick: (contact, $event) => {
                    $event.stopPropagation();
                    navigator.clipboard.writeText(this.generateMeetingShareLink(contact));
                    this.clipboardPopup('meetingroom', $event);
                },
                displayCondition: (contact) => !lodash_2.isNil(contact.actions[contact_sheet_model_1.ContactSheetActionEnum.ShareLink]),
                disableCondition: (contact) => contact.actions['ShareLink'].disable
            },
            'VideoInvite': {
                class: 'video-call',
                id: 'videoinvite-contact-button',
                icon: `
                <span class='nd-action-button'>
                <div class="fa-users-plus-wrapper">
                    <span><i class="fa fa-users fa-users-plus-0"></i></span>
                    <i class="fa fa-plus fa-users-plus-1" aria-hidden="true"></i>
                </div>
                </span>
                `,
                title: 'INVITE_TO_MEETING_ROOM',
                onClick: (contact, $event) => {
                    $event.stopPropagation();
                    this.inviteToMeetingRoom(contact);
                    closeContactSheetCallback === null || closeContactSheetCallback === void 0 ? void 0 : closeContactSheetCallback();
                },
                displayCondition: (contact) => !lodash_2.isNil(contact.actions[contact_sheet_model_1.ContactSheetActionEnum.VideoInvite]) && this.isJitsiAvailable() && this.canInviteToMeetingRoom(contact),
                disableCondition: (contact) => contact.actions['VideoInvite'].disable
            },
            'AudioInvite': {
                class: 'audio-invite',
                id: 'audioinvite-contact-button',
                icon: `
                <span class='nd-action-button invite-to-conference-icon'>
                <span class="xivo-phone-plus-wrapper">
                    <span><i class="xivo-telephone"></i></span>
                    <i class="fa fa-plus xivo-phone-plus" aria-hidden="true"></i>
                    </i>
                </span>
                </span>`,
                title: 'INVITE_TO_CONFERENCE',
                onClick: (contact, $event) => {
                    $event.stopPropagation();
                    this.inviteToConference(contact, $event);
                    closeContactSheetCallback === null || closeContactSheetCallback === void 0 ? void 0 : closeContactSheetCallback();
                },
                displayCondition: (contact) => !lodash_2.isNil(contact.actions[contact_sheet_model_1.ContactSheetActionEnum.AudioInvite]) && this.userWithInviteToConferenceIcon(contact) || this.meetingRoomWithInviteToConferenceIcon(contact),
                disableCondition: (contact) => contact.actions['AudioInvite'].disable
            }
        };
        return actions;
    }
    setInitials(contact) {
        if (!contact.name)
            return;
        contact.initials = (contact.name.match(/\b\w/g) || []).slice(0, 4).join(' ');
        return contact.initials;
    }
    ;
}
exports.default = ContactService;
ContactService.$inject = ['$window', 'callContext', 'JitsiProxy', 'XucPhoneState', 'CtiProxy', '$log', 'applicationConfiguration', '$translate', 'XucUtils', '$state', 'toast'];
